import React, { useState } from 'react';
import { Info, ShieldCheck } from 'lucide-react';

const LEVELS = {
  high: { label: 'High confidence', pill: 'bg-[#6B9F4A]/15 text-[#1A4331]', dot: 'bg-[#6B9F4A]' },
  'medium-high': { label: 'Medium-high confidence', pill: 'bg-[#6B9F4A]/10 text-[#3d5c14]', dot: 'bg-[#B4D330]' },
  medium: { label: 'Medium confidence', pill: 'bg-[#C9A85B]/15 text-[#7A6B57]', dot: 'bg-[#C9A85B]' },
  low: { label: 'Low confidence', pill: 'bg-[#C66B4A]/15 text-[#C66B4A]', dot: 'bg-[#C66B4A]' },
};

export function TrustBadge({ confidence, why, basedOn, testId }) {
  const [open, setOpen] = useState(false);
  if (!confidence) return null;
  const lvl = LEVELS[confidence] || LEVELS.medium;

  return (
    <div data-testid={testId || 'trust-badge'}>
      <div className="flex items-center gap-2 flex-wrap">
        <span className={`inline-flex items-center gap-1.5 text-[11px] font-semibold px-2.5 py-1 rounded-full ${lvl.pill}`}>
          <span className={`w-1.5 h-1.5 rounded-full ${lvl.dot}`}></span>
          {lvl.label}
        </span>
        {(why || basedOn?.length > 0) && (
          <button onClick={() => setOpen(!open)} data-testid={testId ? `${testId}-why` : 'trust-why-button'}
            className="inline-flex items-center gap-1 text-[11px] font-semibold text-[#1A4331] hover:text-[#255C44]">
            <Info className="w-3 h-3" />
            {open ? 'Hide' : 'Why?'}
          </button>
        )}
      </div>
      {open && (
        <div className="mt-2 bg-[#F0F2EB] rounded-xl p-3" data-testid={testId ? `${testId}-explainer` : 'trust-explainer'}>
          {why && (
            <p className="text-xs text-[#2A3528] leading-relaxed flex items-start gap-1.5">
              <ShieldCheck className="w-3.5 h-3.5 text-[#6B9F4A] flex-shrink-0 mt-0.5" />
              {why}
            </p>
          )}
          {basedOn?.length > 0 && (
            <div className="flex flex-wrap gap-1 mt-2">
              {basedOn.map((b, i) => (
                <span key={i} className="text-[10px] px-2 py-0.5 bg-white text-[#7A6B57] rounded-full">{b.replace(/_/g, ' ')}</span>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
